import { FC } from 'react';

import styles from './SpecialProjectBannerSkeleton.css';

type TSpecialProjectBannerSkeletonProps = {
  children: React.ReactNode;
};

export const SpecialProjectBannerSkeleton: FC<TSpecialProjectBannerSkeletonProps> = ({ children }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        <div className={styles['preview']} />
        <div className={styles['content']}>
          {[1, 2].map(item => (
            <div className={styles['line']} key={item} />
          ))}
        </div>
        <div className={styles['layout']}>{children}</div>
      </div>
    </div>
  );
};
